import { useLayoutEffect, useRef } from "react";

const MIN_ROWS = 1;
const MAX_ROWS = 6;

type SearchTextareaProps = {
  value: string;
  onChange: (value: string) => void;
  ariaLabel: string;
  placeholder?: string;
};

/**
 * Ô tìm kiếm nhiều dòng — dùng chung cho BarcodePrintPage + ProductsPage.
 * 1 dòng = 1 token (searchTokens ở từng page). Enter xuống dòng, không submit
 * (không có <form> bao ngoài ở cả 2 nơi dùng).
 * Tự giãn MIN_ROWS..MAX_ROWS dòng theo nội dung; vượt MAX_ROWS thì cuộn nội bộ.
 * Không có resize grip (resize:none trong styles.css).
 */
export function SearchTextarea({ value, onChange, ariaLabel, placeholder }: SearchTextareaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  // useLayoutEffect: đổi rows trước khi browser paint → không nháy khi gõ.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const style = getComputedStyle(el);
    const fontSize = parseFloat(style.fontSize) || 14;
    const lineHeight = parseFloat(style.lineHeight) || fontSize * 1.5;
    const padY = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
    el.rows = MIN_ROWS;
    // scrollHeight làm tròn lên số nguyên, line-height lại lẻ (vd 19.575) → trừ 1px
    // dung sai, nếu không 3 dòng bị đo thành 4.
    const contentRows = Math.ceil((el.scrollHeight - padY - 1) / lineHeight);
    el.rows = Math.min(Math.max(contentRows, MIN_ROWS), MAX_ROWS);
  }, [value]);

  return (
    <div className="search search--multiline">
      <span className="material-symbols-outlined" aria-hidden="true">search</span>
      <textarea
        ref={ref}
        /* Chỉ paint lần đầu; sau đó effect tự quản rows (prop giữ nguyên nên React không ghi lại). */
        rows={MIN_ROWS}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
      />
    </div>
  );
}
